module.exports = __webpack_public_path__ + "img/electric.7a3650b6.jpg";